import { StoreReducer } from "@grassrootly/rn-core";
import AuthReducer from "./auth/AuthReducer";
import GameReducer from "./game/GameReducer";
import GameViewReducer from "./game/GameViewReducer";
import StatsReducer from "./stats/StatsReducer";
import GroupsReducer from "./groups/GroupsReducer";
import PlayersNextGamesReducers from "./players-next-games/PlayersNextGamesReducers";
import PlayersPreviousGamesReducers from "./players-previous-games/PlayersPreviousGamesReducers";
import GroupMatchesReducer from "./groups/GroupMatchesReducer";
import InfoTeamPlayersReducer from "./info-players/InfoTeamPlayersReducer";
import GroupFactsReducers from "./group-facts/GroupFactsReducers";
import EditGroupReducer from "./edit-group/EditGroupReducer";
import CreateGroupReducers from "./create-group/CreateGroupReducers";
import CreateGroupPlayerReducers from "./create-group-player/CreateGroupPlayerReducers";
import JoinGroupReducer from "./join-group/JoinGroupReducer";
import { competitionsReducer } from "./competitions/CompetitionsReducer";

const APIReducers: { [key: string]: StoreReducer } = {
  auth: AuthReducer,
  games: GameReducer,
  gameView: GameViewReducer,
  stats: StatsReducer,
  groups: GroupsReducer,
  players_next_games: PlayersNextGamesReducers,
  players_previous_games: PlayersPreviousGamesReducers,
  group_matches: GroupMatchesReducer,
  info_players: InfoTeamPlayersReducer,
  group_facts: GroupFactsReducers,
  edit_group: EditGroupReducer,
  create_group: CreateGroupReducers,
  create_group_player: CreateGroupPlayerReducers,
  join_group: JoinGroupReducer,
  competitions: competitionsReducer
};

export default APIReducers;
